// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';

import Svg, { SvgProps } from '../Svg';

const PageTop: React.FC<SvgProps> = (props) => (
  <Svg width="60" height="60" {...props} viewBox="0 0 60 60">
    <g data-name="長方形 307" fill="#fff" stroke="currentColor" strokeWidth={2}>
      <rect width="60" height="60" rx="2" stroke="none" />
      <rect x="1" y="1" width="58" height="58" rx="1" fill="none" />
    </g>
    <path
      data-name="パス 129"
      d="M16.109 2.533a2.181 2.181 0 0 1 0 3.083L5.219 16.505a2.18 2.18 0 0 1-3.083-3.083l9.351-9.351-9.344-9.352a2.181 2.181 0 0 1 0-3.083 2.181 2.181 0 0 1 3.083 0l10.89 10.89z"
      transform="rotate(-90 32.527 6.596)"
      fill="currentColor"
    />
  </Svg>
);

PageTop.displayName = 'PageTop';

export default PageTop;
